var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextSlide flex flex-col flex-1 justify-center items-center wrapper-2",style:(_vm.cssVars),on:{"click":_vm.onClick}},[_c('RichText',{attrs:{"className":"TextSlide__text serif","field":_vm.body}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }